import { LABEL_DEAL, LABEL_PPA } from "./constants";
import { findLabelByDomainType } from "../utils/internal";
export var mapLabels = function mapLabels(collection) {
  if (collection) {
    var deal = collection.find(findLabelByDomainType(LABEL_DEAL));
    var ppa = collection.find(findLabelByDomainType(LABEL_PPA));
    return {
      deal: {
        labelKey: deal === null || deal === void 0 ? void 0 : deal.labelKey,
        title: deal === null || deal === void 0 ? void 0 : deal.title
      },
      ppa: {
        labelKey: ppa === null || ppa === void 0 ? void 0 : ppa.labelKey,
        title: ppa === null || ppa === void 0 ? void 0 : ppa.title
      }
    };
  }
  return undefined;
};
//# sourceMappingURL=mapLabels.js.map